module.exports = __webpack_public_path__ + "static/media/vp.12785f4a.png";